<template>
  <v-main>
    <CntNrw v-if="de">
      <br />
      <p>
        Gemeinsam mit Universitäten in Sheffield, Stockholm und Utrecht untersuchen Forscher*innen von der Universität Oldenburg wie der Konsum neuer Rauschmittel zwischen 1600 und 1850 neue öffentliche Räume entstehen ließ und neue Formen von Geselligkeit geprägt hat.
      </p>
      <p>
        Das zweijährige Kooperationsprojekt mit dem Titel „Intoxicating Spaces: The Impact of New Intoxicants on Urban Spaces in Europe, 1600-1850“ erforscht die bedeutendsten nordeuropäischen Hafenstädten Amsterdam, Hamburg, London und Stockholm während dieser ersten Welle der Globalisierung in der Frühen Neuzeit. Weitere Schwerpunkte des Projekts bilden die ständig changierenden Einstellungen zum Rauschmittelkonsum und die oft ausbeuterischen internationalen Strukturen und Handelsbeziehungen, die der Produktion, dem Handel und dem Konsum dieser Produkte zugrunde lagen.
      </p>
      <p>
        Das besondere an dem „Intoxicating Spaces“ Projekt ist, dass die Forschungsergebnisse durch gemeinsame Projekte mit Schulen, Museen, NGOs und internationalen Organisationen als wichtige Perspektive in aktuelle Debatten um Drogen einfließen. Das Projekt wird von dem europäischen Netzwerk Humanities in the European Research Area (HERA) gefördert.
      </p>
    </CntNrw>
    <CntNrw v-if="en">
      <br />
      <p>
        Together with universities in Sheffield, Stockholm and Utrecht, researchers from the University of Oldenburg are investigating how the consumption of new intoxicants between 1600 and 1850 gave rise to new public spaces and shaped new forms of sociability.
      </p>
      <p>
        The two-year collaborative project entitled "Intoxicating Spaces: The Impact of New Intoxicants on Urban Spaces in Europe, 1600-1850" explores the most important northern European port cities of Amsterdam, Hamburg, London and Stockholm during this first wave of globalisation in the early modern period. The project also focuses on the ever-changing attitudes towards intoxicant consumption and the often exploitative international structures and trading networks that underpinned the production, trade and consumption of these products.
      </p>
      <p>
        What is special about the Intoxicating Spaces project is that the research results flow into current debates on drugs as an important perspective through joint projects with schools, museums, NGOs and international organisations. The project is funded by the Humanities in the European Research Area (HERA) network.
      </p>
    </CntNrw>
    <span id="mapC" />
    <CntBrd isc="isBlue" v-if="de">
      <template v-slot:headline>
          Karte
      </template>
      <template v-slot:headlineInBox>
          Kaffe und Kakao auf dem Weg zu den Konsument*innen - <br />Eine interaktive Karte
      </template>
      <template v-slot:left>
        <p>
          Unsere AG erstellte eine interaktive Landkarte, deren Ziel es ist, den Transport und Konsum von Kaffee und Kakao im 19. Jahrhundert nach Hamburg und Umgebung anschaulich darzustellen. Sie ist auf Deutsch und Englisch verwendbar.
        </p>
        <p>
          Alle Texte in der Karte sind aus der Sicht historischer Charaktere verfasst, die jeweils ihre Erfahrung mit Kaffee- und Kakaokonsum erzählen, beispielsweise ein Apotheker oder ein Kaffeehausbesitzer. Die Grundlage ist eine Weltkarte, auf der mehrere Elemente, wie zum Beispiel ein Schiff oder eine Stadt farbig hervorgehoben sind. Bei Berührung dieser Elemente erscheint ein entsprechendes Bild, auf dem wieder mehrere Bereiche hervorgehoben und wählbar sind, zum Beispiel ein Kaffeehaus. Wählt man eines aus, erscheint ein Text mit passenden historischen Bildern zu der Thematik des Kaffees, der gleichzeitig vorgelesen wird.
        </p>
      </template>
      <template v-slot:right>
        <InteractiveMap :lang="lang">
          <p class="caption">
            Die interaktive Karte ist 130 MB groß.Je nach Internetverbindung, entstehen hohe Ladezeiten.
          </p>
        </InteractiveMap>
      </template>
    </CntBrd>
    <CntBrd isc="isBlue" v-if="en">
      <template v-slot:headline>
          Map
      </template>
      <template v-slot:headlineInBox>
          Coffee and Cocoa en Route to Consumers –<br />An Interactive Map
      </template>
      <template v-slot:left>
        <p>
          Our group created an interactive map that is supposed to depict the transport and consumption of coffee and cocoa to Hamburg in the 19th century vividly.<br />
          It is available in English and in German.
        </p>
        <p>
          All the texts in the map are written from the perspective of historical characters, who share their experiences regarding coffee- and cocoa consumption, such as an apothecary or a coffee house owner.The base of the project is a worldmap where various elements, like a city or a ship, are highlighted. When those elements are clicked on, a corresponding image will appear, where there are again several highlighted sections one can select, for example a coffee house.
          When a symbol is selected, a text will pop up with fitting historical pictures, all regarding coffee, whilst the text is simultaneously read out loud.
        </p>
      </template>
      <template v-slot:right>
        <InteractiveMap
          :lang="lang"
        >
          <p class="caption">
            The interactive map is 130 MB in size. Depending on the internet connection, the loading times are long
          </p>
        </InteractiveMap>
      </template>
    </CntBrd>
    <span id="objectsC" />
    <Gallery isc="isBlue" :imgs="objectsCaecilien" :lang="lang">
          {{de?'Museumsobjekte':'Museum objects'}}
    </Gallery>
    <span id="creditsC" />
    <CntBrd isc="isBlue">
      <template v-slot:headline>
          {{de?'Beteiligte':'Involved'}}
      </template>
      <template v-slot:left>
        <v-img
          src="@/assets/credits/P1270281.jpg"
        />
      </template>
      <template v-slot:right>
        <p v-if="de">
          Von der Cäcilienschule beteiligten sich am Projekt
        </p>
        <p v-if="en">
          From the Cecilia School participated in the project
        </p>
        <p>
          Rieke Freudenstein<br />
          Paul Giesmann<br />
          Janna Hinrichs<br />
          Fenja Hübner<br />
          Lisbeth Ritterhoff<br />
          Dido Schwarzer<br />
          Marlena Snieder<br />
          Chiara Urner<br />
          Len Witte
        </p>
        <p v-if="de">
          Und als Lehrerin Ina-Maria Goldbach.<br />
          Die Schüler*innen besuchen aktuell die Klassenstufen 10-12.
        </p>
        <p v-if="en">
          And as a teacher Ina-Maria Goldbach. <br />
          The students are currently attending grades 10-12.
        </p>
      </template>
    </CntBrd>
    <span id="moviesA" />
    <br />
    <CntBrd isc="isRed">
      <template v-slot:headline>
          {{de?'Filme':'Movies'}}
      </template>
      <template v-slot:headlineInBox>
          <span v-if="de">Warum trinken nicht alle Kakao?<br />Aus dem Tagebuch eines Zeitreisenden</span>
          <span v-if="en">Why doesn't everyone drink cocoa?<br />From the diary of a time traveler</span>
      </template>
      <template v-slot:left>
        <p v-if="de">
          Konsumgüter wie Tabak, Kakao und Kaffee gehören für viele von uns zum Alltag und ihr Konsum wird wenig hinterfragt. Aber war das schon immer so?
        </p>
        <p v-if="de">
          Mit dieser Frage haben wir uns auseinandergesetzt und in der Carl von Ossietzky Universität in Oldenburg und im Deutschen Schifffahrtsmuseum recherchiert.
        </p>
        <p v-if="de">
          Um unser erlangtes Wissen zu teilen, haben wir verschiedene Tagebucheinträge im Namen des fiktionalen jungen Erwachsenen Joe geschrieben. Er geht versehentlich auf Zeitreisen, nachdem er gewisse Gegenstände berührt hat. Wir haben uns für das Schreiben eines Tagebuchs entschieden, weil wir unsere Erkenntnisse in einem ansprechenden und einfachen Stil darstellen wollten. Der Charakter, aus dessen Sicht das Tagebuch geschrieben wurde, ist männlich, weil er unter anderem unbegleitet im 18. Jahrhundert ein Kaffeehaus betritt. Dies wäre für eine Frau damals sehr unwahrscheinlich gewesen. Joe ist etwa 18 Jahre alt, da er immer noch zur Schule geht, aber schon als erwachsen durchgehen muss, um nicht aufzufallen.
        </p>
        <p v-if="en">
          Consumer goods like tobacco, cocoa and coffee have become a daily good today and we do not question those who enjoy consuming them. But has it always been this way?
        </p>
        <p v-if="en">
          We have been working on this question by using information we obtained from historians at the Carl von Ossietzky Universität in Oldenburg and the Deutsches Schifffahrtsmuseum.
        </p>
        <p v-if="en">
          We then turned our knowledge into several diary entries by the fictional young adult Joe who accidentally travels in time after touching certain museal objects.
        </p>
        <p v-if="en">
          We have decided to write a diary because we want to convey the available information in an appealing and simple way. The character through whose eyes the story is told is male as he, among other things, enters a coffeehouse unaccompanied which would have been unlikely if he were a woman. Joe is around 18 years old because he is still in school but also needs to pass off as an adult to avoid attracting attention.
        </p>
      </template>
      <template v-slot:right>
        <Movies :movs="movies" />
      </template>
    </CntBrd>
    <span id="objectsA" />
    <Gallery isc="isRed" :imgs="objectsAG" :lang="lang">
          {{de?'Museumsobjekte':'Museum objects'}}
    </Gallery>
    <span id="creditsA" />
    <CntBrd isc="isRed">
      <template v-slot:headline>
          {{de?'Beteiligte':'Involved'}}
      </template>
      <template v-slot:left>
        <v-img
          src="@/assets/credits/IMG_0795_2_verpixelt.jpg"
          style="margin-bottom:20px"
        />
        <v-img
          src="@/assets/credits/551387D2-7D06-4089-BEBC-0E42D947EEC0_2_verpixelt.jpg"
        />
      </template>
      <template v-slot:right>
        <p v-if="de">
          Vom Alten Gymnasium beteiligten sich am Projekt
        </p>
        <p v-if="en">
          From the 'Alten Gymnasium' school participated in the project
        </p>
        <p>
          Madeleine Klattenhoff<br />
          Isabella Meyer – {{de ? 'zusätzlich verantwortlich für die Präsentation im Vorstellungsfilm':'additionally responsible for the presentation in the introduction film'}} <br />
          Philipp Watermann<br />
          Bendix Müller<br />
          Florentine Krieger<br />
          Fiona Logemann<br />
          Emily Gunske<br />
          Svea Lange<br />
          Emma Bocklage – {{de ? 'zusätzlich verantwortlich für die Filme (Schneiden etc.)':'additionally responsible for the films (editing etc.)'}} <br />
          Saskia Diebels<br />
          Nina Hempel<br />
          Lea Wilkowski<br />
          Hanna Noll<br />
          Neele Zhang<br />
          Jana Muke<br />
        </p>
        <p>
          <span v-if="de">Bis Ende des Schuljahrs 2019/2020 bzw. Ende des Jahres 2021 dabei:</span>
          <span v-if="en">Until the end of the 2019/2020 school year or the end of 2021:</span>
          <br />
          Vivien Gierst<br />
          Martha Behrens<br />
          Louisa Reinbold<br />
        </p>
        <p>
          {{de?'Betreuende Lehrkraft:':'Supervising teacher:'}}
          Sabine Conrad
        </p>
      </template>
    </CntBrd>
  </v-main>
</template>
<script>

import CntNrw from '../components/CntNrw' // ContentBox narrow
import CntBrd from '../components/CntBrd' // ContentBox Broad slots-> headline, headlineInBox, left, right
import Gallery from '../components/Gallery' // Image Gallery with lightbox
import Movies from '../components/Movies'
import InteractiveMap from '../components/InteractiveMap'


export default {
  name: 'Home',
  components: {
    CntNrw,
    CntBrd,
    Gallery,
    Movies,
    InteractiveMap
  },
  props: {
    lang: String,
    schhoolclass: String
  },
  data () {
    return {
      movies: [
        {
          src: 'movs/TriptotheDSM.mp4',
          dl: 'movs/DeutscheFilmtexte_Website_TriptotheDSM_1.pdf'
        },
        {
          src: 'movs/Traveling_to_the_17th_century.mp4',
          dl: 'movs/DeutscheFilmtexte_Website_Traveling17thCentury_2.pdf'
        },
        {
          src: 'movs/Traveling_to_the_18th_century.mp4',
          dl: 'movs/DeutscheFilmtexte_Website_Traveling18thCentury_3.pdf'
        },
        {
          src: 'movs/Traveling_to_the_19th_century.mp4',
          dl: 'movs/DeutscheFilmtexte_Website_Traveling19thCentury_4.pdf'
        },
        {
          src: 'movs/Traveling_to_the_60s.mp4',
          dl: 'movs/DeutscheFilmtexte_Website_TravelingSixties_5.pdf'
        }
      ],
      objectsCaecilien: [
        {
          inv: 'I/04522/88',
          de: 'Kakaokanne der Reederei "LEA";\nMarke "Bauscher Weiden BW Bavaria Germany“,\nfabrikdekoriert',
          en: 'Cocoa pot of the shipping company "LEA"',
          timede: '20. Jahrhundert',
          timeen: '20th century',
          src: require('@/assets/expo/I-04522_88-a.jpg')
        },
        {
          inv: 'I/07003/95',
          de: 'Holzrelief "HAMBURGER HAFENARBEITER".\nHafenarbeiter schiebt eine Karre mit Kaffeesack.\nDer Sack hat die Aufschrift "Hamburger Kaffee-Import Thams & Garts"',
          en: 'Wood relief "HAMBURGER DOCK WORKER"',
          timede: '20. Jahrhundert',
          timeen: '20th century',
          src: require('@/assets/expo/I-07003_95-b.jpg')
        },
        {
          inv: 'I/09003/00',
          de: 'Tabakdose aus Messing mit Ansicht von Hamburg',
          en: 'Brass tobacco tin with a view of Hamburg',
          timede: 'ca. 1760',
          timeen: 'circa 1760',
          src: require('@/assets/ag/I-09003_00.jpg')
        },
        {
          inv: 'I/10883/12',
          de: 'Tabakdose aus Holland',
          en: 'Tobacco tin from Holland',
          timede: 'Um 1700',
          timeen: 'around 1700',
          src: require('@/assets/expo/I-10883_12-a.jpg')
        },
        {
          inv: 'IV/00871/92',
          de: 'Wappen aus Holz mit Motiv',
          en: 'Wooden emblem with motive',
          timede: '20. Jahrhundert',
          timeen: '20th century',
          src: require('@/assets/expo/IV-00871_92-a.jpg')
        }
      ],
      objectsAG: [
        {
          inv: 'I/07057/95',
          de: 'Gewürzständer aus Porzellan in Form eines Passagierdampfers.\nKorpus, Gewürzstreuer, Deckel für Senftopf und Senflöffel.',
          en: 'Porcelain cruet in the shape of a passenger steamer.',
          timede: '19. Jahrhundert',
          timeen: '19th century',
          src: require('@/assets/ag/I-07057_95-e.jpg')
        },
        {
          inv: 'I/06234/93',
          de: 'Tabakdose mit Rechentabellen',
          en: 'Tobacco tin with ready reckoner',
          timede: '16. Jahrhundert',
          timeen: '16th century',
          src: require('@/assets/ag/I-06234_93-e.jpg')
        },
        {
          inv: 'I/09003/00',
          de: 'Tabakdose aus Messing mit Ansicht von Hamburg',
          en: 'Brass tobacco tin with a view of Hamburg',
          timede: 'ca. 1760',
          timeen: 'circa 1760',
          src: require('@/assets/ag/I-09003_00.jpg')
        },
        {
          inv: 'I/10883/12',
          de: 'Tabakdose aus Holland',
          en: 'Tobacco tin from Holland',
          timede: 'Um 1700',
          timeen: 'around 1700',
          src: require('@/assets/ag/I-10883_12-a.jpg')
        },
        {
          inv: 'I/09187/00',
          de: 'Hölzerne Tabaksdose in Form eines niederländischen Küstenseglers',
          en: 'Wooden tobacco tin in the shape of a dutch coaster',
          timede: '',
          timeen: '',
          src: require('@/assets/ag/I-09187_00-e.jpg')
        },
        {
          inv: 'I/09524/02',
          de: 'Silberne Tabakdose mit eingravierter Seeschlacht',
          en: 'Silver tobacco tin with an engraved naval battle',
          timede: '',
          timeen: '',
          src: require('@/assets/ag/I-09524_02-e.jpg')
        },
        {
          inv: 'I/00535/73',
          de: 'Pottwalzahn als Tabakgefäß',
          en: 'Sperm whale tooth as a tobacco vessel',
          timede: '19. Jahrhundert',
          timeen: '19th century',
          src: require('@/assets/ag/I-00535_73.jpg')
        },
        {
          inv: 'I/07366/96',
          de: 'Holländische Tabakdose mit graviertem ewigem Kalender',
          en: 'Dutch tobacco tin with an engraved perpetual calendar',
          timede: '18. Jahrhundert',
          timeen: '18th century',
          src: require('@/assets/ag/I-07366_96.jpg')
        }
      ]
    }
  },
  computed: {
    env () {
      return process.env.NODE_ENV;
    },
    de () {
      return this.lang === 'de'
    },
    en () {
      return this.lang !== 'de'
    }
  }
}
</script>
